<template>
  <div class="flex items-baseline">
    <div class="flex-1">
      <div
        class="bg-gray-100 p-3"
        :class="{
          rounded: !customize,
          'rounded-t': customize,
        }"
      >
        <div class="flex -mx-3 items-baseline">
          <div class="flex-1 px-4 py-2">
            <span class="block">{{ entity.name }}</span>
          </div>
          <div class="flex-none px-4">
            <BaseLinkButton
              v-if="selected && hasProductServices"
              green
              @click="toggleCustomizeState"
            >
              διαμορφωση
            </BaseLinkButton>
            <template v-if="entity.optional">
              <BaseLinkButton v-if="!selected" silver @click="add">
                Προσθηκη (+{{ entity.price }} &euro;)
              </BaseLinkButton>

              <BaseLinkButton v-else silver @click="remove"> Αφαιρεση </BaseLinkButton>
            </template>
          </div>
          <div class="w-24 px-4 font-medium text-right border-l">
            <template v-if="(entity.optional && selected) || (!entity.optional && totalPrice > 0)">
              {{ totalPrice }} &euro;
            </template>
            <template v-else> - &euro; </template>
          </div>
        </div>
      </div>
      <div v-show="selected && customize && hasProductServices" class="rounded-b bg-gray-200 p-8">
        <slot :product="product" />
      </div>
    </div>
    <!-- <div
      class="w-24 p-3 font-medium text-right rounded-r"
      :class="{
        'bg-gray-200': (entity.optional && selected) || (!entity.optional && totalPrice > 0),
      }"
    >
      <span v-if="(entity.optional && selected) || (!entity.optional && totalPrice > 0)">
        {{ totalPrice }} &euro;
      </span>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PackageItem',
  props: {
    entity: {
      type: Object,
      required: true,
    },
    selected: Boolean,
  },
  data: () => ({
    customize: false,
  }),
  computed: {
    ...mapState('entities', {
      productsById: (state) => state.products.byId,
    }),
    product() {
      return this.productsById[this.entity.productId];
    },
    hasProductServices() {
      return this.product.productServices && this.product.productServices.length > 0;
    },
    totalPrice() {
      const { selectedProductServices = [] } = this.entity;

      return selectedProductServices.reduce((acc, cur) => {
        if (cur.optional) {
          return acc + cur.price;
        }
        return acc;
      }, this.entity.price);
    },
  },
  methods: {
    toggleCustomizeState() {
      if (this.customize) {
        this.customize = false;
      } else {
        this.customize = true;
        this.$emit('customizing', this.entity.id);
      }
    },
    add() {
      this.$emit('add', { ...this.entity });
    },
    remove() {
      this.customize = false;
      this.$emit('remove', { ...this.entity });
    },
  },
};
</script>
